import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageNotFoundComponent} from '@common/pages/page_not_found/page-not-found.component';

const routes: Routes = [
    {
        path: "",
        children: [
            {
                path: "", redirectTo: "greeting", pathMatch: "full"
            },
            {
                path: 'external',
                loadChildren: () => import("./external/external.module").then(m => m.ExternalModule)
            },
            {
                path: "login",
                loadChildren: () => import("./authorization/authorization.module").then(m => m.AuthorizationModule)
            },
            {
                path: "greeting",
                loadChildren: () => import("./greeting/greeting.module").then(m => m.GreetingModule)
            },
            {
                path: "housing-organization",
                loadChildren: () => import("./sections/organization-cabinet/organization-cabinet.module").then(m => m.OrganizationCabinetModule)
            },
            {
                path: "business-organization",
                loadChildren: () => import("./sections/organization-cabinet/organization-cabinet.module").then(m => m.OrganizationCabinetModule)
            },
            {
                path: "tenant",
                loadChildren: () => import("./sections/tenant-cabinet/tenant-cabinet.module").then(m => m.TenantCabinetModule)
            },
            {
                path: '**', component: PageNotFoundComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule {
}
